import { useQuery } from "@tanstack/react-query";

import { BrokersApi } from "../api/brokersApi";

export const BrokerQueryKeys = {
  all: ["brokers"] as const,
  current: () => [...BrokerQueryKeys.all, "current"] as const,
};

export const useBrokerQuery = () => {
  return useQuery({
    queryKey: BrokerQueryKeys.current(),
    queryFn: () => BrokersApi.getBroker(),
  });
};
